import React from 'react';
import Modal from "./components/Modals/Modal";
import SuccsesCashSnake from "./components/Modals/components/SuccsesFreeSpins/SuccsesFreeSpins";
import { Spin } from 'antd';
import SpinLoad from "./components/UI/Spin/Spin";
import Winner from './components/UI/Winner/Winner';
import InfoWagering from './Pages/Payments/components/InfoWagering/InfoWagering';



class VibrationComponent extends React.Component {

    
    render() {
        return (
            <div style={{display:"flex",justifyContent:"center"}}>
            <InfoWagering amount_bonus={500} sum_bets={10} amount_payin={1000} status={0} amount_last={1000} count_payin={0}/>
           

            </div>
        )
    }
}

export default VibrationComponent;
